/**
 * GameSetup - Pantalla de configuración de partida X01
 * 501 Dart League Web
 * 
 * Permite configurar:
 * - Número de jugadores (1 o 2)
 * - Nombres de jugadores
 * - Modo de juego (301, 501, 701)
 * - Legs para ganar (1-7)
 */

import React, { useState } from 'react';
import './styles/index.css';
import './styles/x01game.css';

const GameSetup = ({ onBack, onStartGame, user }) => {
  const username = user?.username || 'Jugador 1';
  const [playerCount, setPlayerCount] = useState(2);
  const [gameMode, setGameMode] = useState(501);
  const [legsToWin, setLegsToWin] = useState(3);
  const [player2Name, setPlayer2Name] = useState('');

  const handleStart = () => {
    onStartGame({
      playerCount,
      gameMode,
      legsToWin,
      player1Name: username,
      player2Name: playerCount === 2 ? (player2Name.trim() || 'Jugador 2') : null,
    });
  };

  return (
    <div className="dart-league-dashboard training-menu-container">
      <header className="training-menu-header">
        <div className="training-header-top">
          <button className="training-back-btn" onClick={onBack}>
            ← Volver
          </button>
        </div>
        <div className="training-header-icon">
          <img src="/Logo26.png" alt="501 Dart League" className="training-header-logo" />
        </div>
        <h1 className="training-menu-title">Partida X01</h1>
        <p className="training-menu-subtitle">Configura tu partida</p>
      </header>

      <main className="x01-setup-form">
        {/* Número de jugadores */}
        <div className="x01-setup-section">
          <label className="x01-setup-label">Jugadores</label>
          <div className="x01-setup-toggle-group">
            <button
              className={`x01-toggle-btn ${playerCount === 1 ? 'active' : ''}`}
              onClick={() => setPlayerCount(1)}
            >
              1 Jugador
            </button>
            <button
              className={`x01-toggle-btn ${playerCount === 2 ? 'active' : ''}`}
              onClick={() => setPlayerCount(2)}
            >
              2 Jugadores
            </button>
          </div>
        </div>

        {/* Nombre del jugador 1 (usuario logueado - solo lectura) */}
        <div className="x01-setup-section">
          <label className="x01-setup-label">
            {playerCount === 1 ? 'Tu nombre' : 'Jugador 1'}
          </label>
          <input
            type="text"
            className="x01-setup-input x01-setup-input-readonly"
            value={username}
            readOnly
            disabled
          />
        </div>

        {playerCount === 2 && (
          <div className="x01-setup-section">
            <label className="x01-setup-label">Jugador 2</label>
            <input
              type="text"
              className="x01-setup-input"
              placeholder="Nombre del rival"
              value={player2Name}
              onChange={(e) => setPlayer2Name(e.target.value)}
              maxLength={20}
              autoFocus
            />
          </div>
        )}

        {/* Modo de juego */}
        <div className="x01-setup-section">
          <label className="x01-setup-label">Modo de juego</label>
          <div className="x01-setup-toggle-group three">
            {[301, 501, 701].map(mode => (
              <button
                key={mode}
                className={`x01-toggle-btn ${gameMode === mode ? 'active' : ''}`}
                onClick={() => setGameMode(mode)}
              >
                {mode}
              </button>
            ))}
          </div>
        </div>

        {/* Legs para ganar */}
        <div className="x01-setup-section">
          <label className="x01-setup-label">Legs para ganar</label>
          <div className="x01-setup-toggle-group legs">
            {[1, 2, 3, 4, 5, 6, 7].map(n => (
              <button
                key={n}
                className={`x01-toggle-btn small ${legsToWin === n ? 'active' : ''}`}
                onClick={() => setLegsToWin(n)}
              >
                {n}
              </button>
            ))}
          </div>
        </div>

        {/* Resumen */}
        <div className="x01-setup-summary">
          <span>Best of {legsToWin * 2 - 1}</span>
          <span>•</span>
          <span>Primero a {legsToWin} legs</span>
        </div>

        {/* Botón de inicio */}
        <button className="x01-start-btn" onClick={handleStart}>
          <span className="x01-start-icon">🎯</span>
          COMENZAR PARTIDA
        </button>
      </main>
    </div>
  );
};

export default GameSetup;
